import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DataLayerCustomDimensionsService } from './data-layer-custom-dimensions.service';
import { PartialCustomDimensionsSet } from './data-layer-custom-dimensions.service';
@Injectable()
export class AnalyticsService {
  constructor(
    private _dataLayerCustomDimensions: DataLayerCustomDimensionsService,
    private _router: Router
  ) {}

  pageView(someDimensions: PartialCustomDimensionsSet, overridePath?: string) {
    this._dataLayerCustomDimensions.dimensions = someDimensions;
    this._dataLayerCustomDimensions.trigger();
    // (<any>window).dataLayer.push({
    //   // this._dataLayerCustomDimensions.dimensions = someDimensions,
    //   event: 'userInfo',
    //   virtualPageURL: overridePath || this._router.url,
    // });
  }
}
